import { Link } from 'react-router-dom';
import { Plus, ChevronRight } from 'lucide-react';
import { useTenants } from './tenants.api';

export function TenantsListPage(): JSX.Element {
  const { data, isLoading } = useTenants();

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Empresas</h1>
          <p className="text-sm text-muted-foreground">Tenants de la plataforma.</p>
        </div>
        <Link
          to="/empresas/nueva"
          className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm shadow-primary/30"
        >
          <Plus className="h-4 w-4" /> Nueva empresa
        </Link>
      </div>

      {isLoading ? (
        <p className="text-sm text-muted-foreground">Cargando…</p>
      ) : (
        <div className="rounded-2xl border border-border bg-card divide-y shadow-sm">
          {(data ?? []).length === 0 && (
            <p className="px-4 py-6 text-sm text-muted-foreground">Sin empresas aun.</p>
          )}
          {(data ?? []).map((t) => (
            <Link
              key={t.id}
              to={`/empresas/${t.id}`}
              className="flex items-center gap-3 px-4 py-3.5 hover:bg-accent transition-colors"
            >
              <div className="h-9 w-9 rounded-full bg-primary/15 text-primary grid place-items-center text-sm font-semibold">
                {t.businessName.charAt(0).toUpperCase()}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium truncate">{t.businessName}</p>
                <p className="text-xs text-muted-foreground">
                  RUC {t.ruc}
                  {t.tradeName && ` · ${t.tradeName}`}
                </p>
              </div>
              <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
